import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { HttpService } from '../../shared/services/http.service';
import { environment as env } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TipologicheService {
  private options;

  constructor(private readonly http: HttpService) {
    this.options = {};
  }

  getTypeTypology(idTypology?: any): Observable<any> {

    return this.http.get<any>(env.baseUrl + 'Typology/Facility' + (idTypology ? '?idTypeTypology=' + idTypology : '')); 
  }

  getSurgeryTypology(): Observable<any> {
    return this.http.get<any>(env.baseUrl + 'Typology/Type'); 
  }

  getTypologyId(idTypology: any, isf?:string, noLoader:boolean = false): Observable<any> {
    let params = new HttpParams()
      .set('idTypeTypology', idTypology);
    if (isf) {
      params = params.set('role', isf);
    }
    return this.http.get<any>(env.baseUrl + 'Typology/', { params, noLoader });
  }

  deleteTipology(id: number): Observable<any> {
    return this.http.delete<any>(env.baseUrl + `Typology/${id}`);
  }

  storeTypology(typology: any): Observable<any> {
    return this.http.post<any>(env.baseUrl + `Typology`, typology);
  }

  updateTypology(typology: any): Observable<any> {
    return this.http.put<any>(env.baseUrl + `Typology`, typology);
  }

  getMacroCategories(): Observable<any> {
    return this.http.get<any>(env.baseUrl + 'Typology/MacroCategory');
  }

  getUsers(page?: number, size?: number, filters?: any): Observable<any> {
      let params = new HttpParams();

      if (filters) {
        Object.keys(filters).forEach(key => {
          const value = filters[key];

          if (Array.isArray(value)) {
            value.forEach(v => {
              params = params.append(key, v);
            });
          } else if (value !== null && value !== undefined && value !== '') {
            params = params.set(key, value);
          }
        });
      }

      if (page !== undefined) {
        params = params.set('page', page);
      }

      if (size !== undefined) {
        params = params.set('pageResults', size);
      }

      return this.http.get<any>(
        env.baseUrl + 'User',
        {
          ...this.options,
          params
        }
    );
  }

  getArea(params?: Record<string, any>): Observable<any> {
    const url = env.baseUrl + 'Area';

    let httpParams = new HttpParams();

    if (params) {
      Object.keys(params).forEach(key => {
        const value = params[key];

        if (Array.isArray(value)) {

          value.forEach(v => {
            if (v !== null && v !== undefined) {
              httpParams = httpParams.append(key, v);
            }
          });
        } else if (value !== null && value !== undefined) {
          httpParams = httpParams.append(key, value);
        }
      });
    }

    return this.http.get<any>(url, { params: httpParams });
  }
}
